import { render, staticRenderFns } from "./FrontProductList.vue?vue&type=template&id=79042b84&"
import script from "./FrontProductList.vue?vue&type=script&lang=js&"
export * from "./FrontProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports